import React, { ReactNode } from 'react';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';

interface CoachAiButtonProps {
  topSubtitle?: ReactNode;
  height?: number;
  width?: number;
}

export const CoachAiButton = ({}: CoachAiButtonProps) => {
  const handleExternalRedirect = () => {
    try {
      if (window.open) {
        window.open(
          'https://coachai.csld.amazon.dev/login/',
          '_blank',
          'noopener,noreferrer'
        );
      }
    } catch (error) {
      // Silently handle popup blocking or other window.open errors
      console.warn('Failed to open CoachAI in new window:', error);
    }
  };

  return (
    <>
      <Row alignmentHorizontal='end'>
        <Button type='tertiary' size='medium' onClick={handleExternalRedirect}>
          <FormattedMessage
            id='cs_perfportal_coachai'
            defaultMessage='CoachAI'
            description='CoachAI'
          />
        </Button>
      </Row>
    </>
  );
};

export default CoachAiButton;
